import {
  dateTimeLocale,
  displayTimeZone,
} from "shared/utils/dateTimeFormatting";

export const tableDateFormatter = (dateString: string) => {
  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return "N/A";
  }

  return new Intl.DateTimeFormat(dateTimeLocale, {
    timeZone: displayTimeZone,
  }).format(date);
};
